import { FC, useEffect, useState } from 'react';
import Slider from 'react-slick';
import { IconButton, Stack } from '@mui/material';
import { ChartFuelSaving } from '../ChartFuelSaving';
import { ChartCO2Reduction } from '../ChartCO2Reduction';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import { SimulationSavings } from '@services/simulation';

export interface IExecuteSummarySavingProps {
	savings?: SimulationSavings;
}

export const ExecuteSummarySaving: FC<IExecuteSummarySavingProps> = ({ savings }) => {
	const [activeElement, setActiveElement] = useState(0);
	const [sliderRef, setSliderRef] = useState<Slider>();

	useEffect(() => {
		try {
			sliderRef?.slickGoTo(activeElement >= 0 ? activeElement : 0);
		}
		catch {
			// noop
		}
	}, [activeElement, sliderRef]);

	return (
		<Stack direction="column" alignItems="center" spacing={2}>
			<div style={{ width: '100%' }}>
				<Slider
					ref={(ref) => ref && !sliderRef && setSliderRef(ref)}
					dots={false}
					arrows={false}
					draggable={false}
					infinite
					speed={500}
					slidesToShow={1}
					slidesToScroll={1}
				>
					<ChartFuelSaving savings={savings} />
					<ChartCO2Reduction savings={savings} />
				</Slider>
			</div>

			<Stack direction="row">
				<IconButton
					disabled={activeElement <= 0}
					onClick={() => setActiveElement(activeElement - 1)}
					sx={{ color: 'common.black', visibility: activeElement <= 0 ? 'hidden' : 'visible' }}
				>
					<ArrowRightAltIcon color="inherit" sx={{ transform: 'rotate(180deg)' }} />
				</IconButton>
				{new Array(2).fill(0).map((_, i) => {
					return (
						<IconButton key={`slider-nav-${i}`} disableRipple onClick={() => setActiveElement(i)}>
							{i === activeElement ? (
								<CircleIcon sx={{ width: 12, height: 12, color: 'common.black' }} />
							) : (
								<CircleOutlinedIcon sx={{ width: 12, height: 12, color: 'common.black' }} />
							)}
						</IconButton>
					);
				})}

				<IconButton
					disabled={activeElement >= 1}
					onClick={() => setActiveElement(activeElement + 1)}
					sx={{ color: 'common.black', visibility: activeElement >= 1 ? 'hidden' : 'visible' }}
				>
					<ArrowRightAltIcon color="inherit" />
				</IconButton>
			</Stack>
		</Stack>
	);
};
